var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPhoto = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.9102,
    cy: 19.108,
    r: 19,
    fill: "#ACCE42"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6073 27.43H12.2713C12.0053 27.43 11.7773 27.202 11.7773 26.936V11.47C11.7773 11.204 12.0053 10.976 12.2713 10.976H27.7373C28.0033 10.976 28.2313 11.204 28.2313 11.47V26.936C28.2313 27.202 28.0033 27.43 27.7373 27.43H25.9513",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7773 21.274L15.4253 16.714C15.6153 16.486 15.9953 16.486 16.1853 16.714L19.8333 21.388C20.0233 21.616 20.3653 21.654 20.5553 21.426L23.6333 18.348C23.8233 18.158 24.1273 18.158 24.3173 18.348L28.2313 22.262",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.303 16.543C22.1845 16.543 22.899 15.8284 22.899 14.947C22.899 14.0655 22.1845 13.351 21.303 13.351C20.4216 13.351 19.707 14.0655 19.707 14.947C19.707 15.8284 20.4216 16.543 21.303 16.543Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.910156 0.107971H38.9102V38.108H0.910156V0.107971Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.4102,
    y: 9.60797,
    width: 19,
    height: 19,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhoto, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Photo.936c7ddf.svg";
export { ForwardRef as ReactComponent };